/* WG CRO additions - Aug 2026
   Additive only. Revert by deleting the WG CRO block at the bottom of layout/theme.liquid.
   Note: the free-shipping bar and the cart-upsell filtering live natively in
   assets/wg-cart-drawer.js - deliberately NOT duplicated here. */
(function () {
  'use strict';
  var C = window.WG_CRO || {};
  var isUS = (C.country || 'US') === 'US';
  var MIN_STARS = typeof C.minStars === 'number' ? C.minStars : 4;
  var MIN_REVIEWS = typeof C.minReviews === 'number' ? C.minReviews : 1;

  /* handle -> [avg, count] */
  var RATINGS = {};
  (C.ratings || []).forEach(function (r) {
    if (r && r[2] > 0) RATINGS[r[0]] = [parseFloat(r[1]) || 0, parseInt(r[2], 10) || 0];
  });

  function fmt(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function isPDP() {
    var m = document.getElementById('MainContent');
    return !!(m && (m.dataset.template || '').indexOf('product') === 0);
  }

  /* ---------- star markup: fractional fill, snapped to nearest half ---------- */
  function starsHTML(avg) {
    var half = Math.round(avg * 2) / 2;          /* 4.36 -> 4.5 */
    var pct = (half / 5) * 100;                  /* 4.5  -> 90% */
    return '<span class="wg-stars" role="img" aria-label="' + avg.toFixed(1) + ' out of 5 stars">' +
      '<span class="wg-stars__bg" aria-hidden="true">★★★★★</span>' +
      '<span class="wg-stars__fg" aria-hidden="true" style="width:' + pct + '%">★★★★★</span>' +
      '</span>';
  }

  /* ---------- 1. Trust lines under the buy button ---------- */
  function trustLines() {
    if (!isPDP() || document.querySelector('.wg-trust')) return;
    var form = document.querySelector('form.shopify-product-form');
    if (!form || !form.parentNode) return;
    var box = document.createElement('div');
    box.className = 'wg-trust';
    var html = '';
    if (C.bogo) html += '<span class="wg-trust__bogo">' + C.bogo + '</span>';
    html += '<span class="wg-trust__ship">' + (isUS
      ? '$8 flat US shipping · 3–4 days · Free over ' + fmt(C.freeUS || 10000)
      : 'Free international shipping over ' + fmt(C.freeIntl || 15000)) + '</span>';
    box.innerHTML = html;
    form.parentNode.insertBefore(box, form.nextSibling);
  }

  /* ---------- 2. Rating under the product title (PDP) ---------- */
  function pdpRating() {
    if (!isPDP() || document.querySelector('.wg-rating:not(.wg-rating--card)')) return;
    var avg = parseFloat(C.rating || 0), n = parseInt(C.ratingCount || 0, 10);
    if (!n || !avg) return;
    var title = document.querySelector('h1.wg-p-title') || document.querySelector('#MainContent h1');
    if (!title || !title.parentNode) return;
    var a = document.createElement('a');
    a.className = 'wg-rating';
    a.href = '#judgeme_product_reviews';
    a.innerHTML = starsHTML(avg) +
      '<span class="wg-rating__text">' + avg.toFixed(1) + ' · ' + n + ' review' + (n === 1 ? '' : 's') + '</span>';
    a.addEventListener('click', function (e) {
      var w = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews');
      if (w) { e.preventDefault(); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    title.parentNode.insertBefore(a, title.nextSibling);
  }

  /* ---------- 3. Cards: stars only at MIN_STARS / MIN_REVIEWS and above ---------- */
  function cardRatings() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.closest('.wg-product')) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (!m) continue;
      var data = RATINGS[m[1]];
      if (!data || data[0] < MIN_STARS || data[1] < MIN_REVIEWS) continue;

      var host = link.querySelector('.wg-card__title, .product-card__title, .card__heading, h2, h3') || link;
      if (host.parentNode && host.parentNode.querySelector(':scope > .wg-rating--card')) continue;
      if (host.querySelector && host.querySelector('.wg-rating--card')) continue;

      var span = document.createElement('span');
      span.className = 'wg-rating wg-rating--card';
      span.innerHTML = starsHTML(data[0]) +
        '<span class="wg-rating__text">' + data[0].toFixed(1) + ' (' + data[1] + ')</span>';
      span.style.display = 'flex';
      if (host === link) link.appendChild(span);
      else host.parentNode.insertBefore(span, host.nextSibling);
    }
  }

  function runAll() {
    try { trustLines(); } catch (e) {}
    try { pdpRating(); } catch (e) {}
    try { cardRatings(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll);
  else runAll();

  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; runAll(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
